import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { ListItemText, MenuItem } from '@material-ui/core';
import { NEW_TAB } from 'consts';

const Product = forwardRef(
  ({ id, name, onClick, onSelect, palRefreshEnabled, url }, ref) => {
    const handleClick = (event) => {
      if (palRefreshEnabled && onSelect) {
        onSelect({ id, name, url }, event);
        return;
      }
      window.open(url, NEW_TAB);
      onClick(event);
    };

    return (
      <MenuItem ref={ref} onClick={handleClick}>
        <ListItemText primary={name} />
      </MenuItem>
    );
  }
);

Product.displayName = 'Product';

Product.propTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  name: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  onSelect: PropTypes.func,
  palRefreshEnabled: PropTypes.bool,
  url: PropTypes.string.isRequired,
};

Product.defaultProps = {
  id: undefined,
  onSelect: undefined,
  palRefreshEnabled: false,
};

export default Product;
